import { useRef, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";
import ReactHtmlParser from "react-html-parser";
import YoutubeVideoPlayer from "components/Dashboard/YoutubeVideoPlayer";
import ButtonComp from "./ButtonComp";

const HomeHeroSection = ({ videosURLObject = [] }) => {
  const scrollRef = useRef(null);

  useEffect(() => {
    const slider = scrollRef.current;
    if (!slider) return;
    let isDown = false;
    let startX;
    let scrollLeft;

    const handleMouseDown = (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    };

    const handleMouseLeave = () => {
      isDown = false;
      slider.classList.remove("active");
    };

    const handleMouseUp = () => {
      isDown = false;
      slider.classList.remove("active");
    };

    const handleMouseMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2; // scroll speed
      slider.scrollLeft = scrollLeft - walk;
    };

    // Touch support
    const handleTouchStart = (e) => {
      startX = e.touches[0].pageX;
      scrollLeft = slider.scrollLeft;
    };

    const handleTouchMove = (e) => {
      const x = e.touches[0].pageX;
      const walk = (x - startX) * 2;
      slider.scrollLeft = scrollLeft - walk;
    };

    slider.addEventListener("mousedown", handleMouseDown);
    slider.addEventListener("mouseleave", handleMouseLeave);
    slider.addEventListener("mouseup", handleMouseUp);
    slider.addEventListener("mousemove", handleMouseMove);

    slider.addEventListener("touchstart", handleTouchStart);
    slider.addEventListener("touchmove", handleTouchMove);

    return () => {
      slider.removeEventListener("mousedown", handleMouseDown);
      slider.removeEventListener("mouseleave", handleMouseLeave);
      slider.removeEventListener("mouseup", handleMouseUp);
      slider.removeEventListener("mousemove", handleMouseMove);

      slider.removeEventListener("touchstart", handleTouchStart);
      slider.removeEventListener("touchmove", handleTouchMove);
    };
  }, []);
  return (
    <section
      className="hero-banner position-relative text-white"
      style={{ paddingTop: "140px" }}
    >
      <div className="custom-container text-center">
        {/* Top Badge */}
        {/* <div className="students-stat mb-3">
          
        </div> */}
        <div className="students-stat mb-4">
          <p className="FS18FW400 fw-600 mb-0">
            Best PTE Training Institute, NAATI CCL & IELTS Preparation Center
          </p>
        </div>

        {/* Heading */}
        <h1 className="FS56FW500 top-section-text">
          Achieve Your Dream Score and Secure Your <br />
          Future with{" "}
          <span className="text-success FS56FW500 fw-600">AI Practice & Guidance.</span>
        </h1>

        {/* Description */}
        <p className="plus-sans FS20FW500 mt-3">
          {ReactHtmlParser("Proven strategies, real-time AI feedback, and Australia's most accurate practice platform —<br/> everything you need to score high in PTE, NAATI CCL, or IELTS.")}
        </p>

        {/* CTA */}
        <div className="align-content-center align-items-center d-flex gap-4 flex-column flex-lg-row justify-content-center mt-5">
        {/* <button 
  className="primary-btn w-auto" 
  data-bs-toggle="modal"
  data-bs-target="#staticBackdrop"
>
  Book Your Free Trial Class
  <img
    src={`/images/web-new-images/new-dark-arrow.svg`}
    alt="Register Now"
  />
</button> */}
        <ButtonComp className={'primary-btn'} link={() => { const modal = new window.bootstrap.Modal(document.getElementById('staticBackdrop')); modal.show(); }} btnText="Book Your Free Trial Class" img="/images/web-new-images/new-dark-arrow.svg"/>

        <button className="border-btn gap-2 primary-btn w-sm-100 w-auto" onClick={() => window.location.href = "/auth/register"}>Free Mock Test<img
                      src={`/images/web-new-images/new-green-arrow.png`}
                      alt="Register Now"
                    />
        </button>
        <div className="join-community d-flex align-items-center justify-content-center justify-content-lg-start gap-5 gap-md-3">
          <div className="avatars d-flex">
            <img src="/images/web-new-images/new-content-slider/SahidaKhatun-demo.webp" alt="user" className="avatar rounded-circle" />
            <img src="/images/web-new-images/new-content-slider/DilmeetKingra-demo.svg" alt="user" className="avatar rounded-circle ms-n3" />
            <img src="/images/web-new-images/new-content-slider/JayPatel-demo.svg" alt="user" className="avatar rounded-circle ms-n3" />
            <img src="/images/web-new-images/new-content-slider/SapnaPandey-demo.svg" alt="user" className="avatar rounded-circle ms-n3" />
          </div>
          <div>
               <div className="d-flex gap-2 justify-content-center justify-content-md-start">
                {[...Array(5)].map((_, index) => (
                <svg key={index} width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.30801 0L10.2693 6.90983H16.6162L11.4815 11.1803L13.4428 18.0902L8.30801 13.8197L3.17327 18.0902L5.13456 11.1803L-0.00017643 6.90983H6.34671L8.30801 0Z" fill="#F0C522"/>
                </svg>
                ))}
                </div>
          <span className="join-text FS14FW600 fw-500">Trusted by 50,000+ students'</span>
          </div>
        </div>
        </div>
        <div className="tropiline FS32 fw-700 text-center my-5">
          <span>Tips From Varun Dhawan, 14x PTE 90 Scorer</span>
        </div>
        {/* Slider */}
        {/* <div className="hero-slider mt-5 d-flex overflow-auto" ref={scrollRef}>
          {images.map((img, index) => (
            <div className="hero-card" key={index}>
              <img src={img} alt="slide" loading={index === 0 ? "eager" : "lazy"}
                fetchPriority={index === 0 ? "high" : "low"} />
            </div>
          ))}
        </div> */}

        <VideoSlider videos={videosURLObject} />
      </div>
    </section>
  );
};

const VideoSlider = ({ videos }) => {
  const [activeVideo, setActiveVideo] = useState(null);
  const [loadedByIndex, setLoadedByIndex] = useState({});
  
  const getYoutubeId = (url) => {
    const regExp =
      /(?:youtube\.com\/(?:shorts\/|watch\?v=)|youtu\.be\/)([^&?/]+)/;
    const match = url.match(regExp);
    return match ? match[1] : "";
  };

  const getYoutubeThumbnail = (url) => {
    const id = getYoutubeId(url);
    return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
  };

  return (
    <>
      {/* SLIDER */}
      <div className="hero-slider reels-section mt-4 d-flex overflow-auto gap-3">
        {/* {videos.map((video, index) => (
          <div className="hero-card" key={index}>
            <div
              className="video-thumbnail position-relative cursor-pointer"
              onClick={() => setActiveVideo(video)}
            >
              <img
                src={video.thumbnail}
                alt="video"
                className="img-fluid rounded-4"
                loading="lazy"
              />

              <div className="play-btn">▶</div>
            </div>
          </div>
        ))} */}
        <Swiper
          modules={[FreeMode]}
          spaceBetween={3}
          slidesPerView={5.5}
          freeMode={{
            enabled: true,
            momentum: true,
            momentumBounce: false,
          }}
          grabCursor={true}
          breakpoints={{
            1800: { slidesPerView: 5.5 },
            1400: { slidesPerView: 4.5 },
            1200: { slidesPerView: 4.2 },
            // 1100: { slidesPerView: 3.8 },
            900: { slidesPerView: 4.2 },
            576: { slidesPerView: 3.5},
            425: { slidesPerView: 2.5 },
            375: { slidesPerView: 2 },
            320: { slidesPerView: 2 },
          }}
        >
          {videos.map((video, index) => (
            <SwiperSlide key={index}>
              <div className="hero-card">
                <div
                  className="video-thumbnail position-relative cursor-pointer"
                  onClick={() => setActiveVideo(video)}
                >
                  <img
                    src={video.thumbnail}
                    alt="video"
                    className={`img-fluid ${loadedByIndex[index] ? "" : "img-loading waveform"}`}
                    loading="lazy"
                    onLoad={() => setLoadedByIndex((prev) => ({ ...prev, [index]: true }))}
                    onError={() => setLoadedByIndex((prev) => ({ ...prev, [index]: true }))}
                  />

                  <div className="play-btn play-btn-hero">▶</div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* POPUP (ONLY ONE) */}
      {activeVideo && activeVideo.type === "youtube" && (
        <YoutubeVideoPlayer
          isOpen={true}
          toggle={() => setActiveVideo(null)}
          videoUrl={`https://www.youtube.com/embed/${getYoutubeId(
            activeVideo.url
          )}?autoplay=1`}
        />
      )}
    </>
  );
};

export default HomeHeroSection;
